<template>
	<v-container fluid>
		<div v-if="!loading">
			<div v-if="adjustedSales.length">
				<v-row class="total secondary--text">
					Sales (units, retail prices, ex-works prices)
				</v-row>
				<!--table head-->
				<v-row class="total mt-8" no-gutters>
					<v-col cols="2" class="tabCell text-left">Products</v-col>
					<v-col v-for="month in 12"
						class="tabCell text-right"
						:key="month">{{monthName(month)}}
					</v-col>
					<v-col class="tabCell text-right">Total (year)</v-col>
				</v-row>
				<!--table content-->
				<v-expansion-panels multiple v-model="panel">
					<v-expansion-panel
						v-for="brand in prevProducts"
						:key="brand.id"
					>
						<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
							{{ brand.trademark }}
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<div v-for="model in sortedModels(brand.models)" :key="model.id" class="mb-3">
								<v-row no-gutters><!--units-->
									<v-col cols="2" class="tabCell text-left">{{ name(model.model) }} (units)</v-col>
									<v-col v-for="month in 12" :key="month"
										class="tabCell text-right">
										{{ format(modelSales(month, model)) }}
									</v-col>
									<v-col class="tabCell text-right total">{{format(yearSales(model))}}</v-col>
								</v-row>
								<!--retail prices-->
								<v-row no-gutters>
									<v-col cols="2" class="tabCell text-left">{{ name(model.model) }} (retail price)</v-col>
									<v-col v-for="month in 12" :key="month"
										class="tabCell text-right">
										{{ format(modelSales(month, model) * model.retailPrice) }}
									</v-col>
									<v-col class="tabCell text-right total">{{format(yearSales(model) * model.retailPrice)}}</v-col>
								</v-row>
								<!--ex-works prices-->
								<v-row no-gutters>
									<v-col cols="2" class="tabCell text-left">{{ name(model.model) }} (ex-works price)</v-col>
									<v-col v-for="month in 12" :key="month"
										class="tabCell text-right">
										{{ format(modelSales(month, model) * model.price) }}
									</v-col>
									<v-col class="tabCell text-right total">{{format(yearSales(model) * model.price)}}</v-col>
								</v-row>
							</div>
							<!--total trademark sales (units)-->
							<v-row v-if="brand.models.length > 1" class="total mb-3" no-gutters>
								<v-col cols="2" class="tabCell text-left">Total {{brand.trademark}} (units)</v-col>
								<v-col v-for="month in 12"
									class="tabCell text-right"
									:key="month">{{format(trademarkSales(month, brand.trademark))}}
								</v-col>
								<v-col class="tabCell text-right">{{format(yearBrandSales(brand.trademark))}}</v-col>
							</v-row>
						</v-expansion-panel-content>
						
					</v-expansion-panel>
				</v-expansion-panels>
				<!--total sales (units)-->
				<v-row class="total mx-4 mt-2" no-gutters>
					<v-col cols="2" class="tabCell text-left">Total (units)</v-col>
					<v-col v-for="month in 12"
						class="tabCell text-right"
						:key="month">{{format(allModelsSales(month))}}
					</v-col>
					<v-col class="tabCell text-right">{{format(yearModelsSales())}}</v-col>
				</v-row>
				<!--total sales (retail price)-->
				<v-row class="total mx-4" no-gutters>
					<v-col cols="2" class="tabCell text-left">Total (retail price)</v-col>
					<v-col v-for="month in 12"
						class="tabCell text-right"
						:key="month">{{format(allModelsSales(month, 'retailPrice'))}}
					</v-col>
					<v-col class="tabCell text-right">{{format(yearModelsSales('retailPrice'))}}</v-col>
				</v-row>
				<!--total sales (ex-works price)-->
				<v-row class="total mx-4" no-gutters>
					<v-col cols="2" class="tabCell text-left">Total (ex-works price)</v-col>
					<v-col v-for="month in 12"
						class="tabCell text-right"
						:key="month">{{format(allModelsSales(month, 'price'))}}
					</v-col>
					<v-col class="tabCell text-right">{{format(yearModelsSales('price'))}}</v-col>
				</v-row>
			</div>
			<div v-else>
				<v-row class="total" justify="center">
					Select the round & press the button "load", please
				</v-row>
			</div>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import numeral from 'numeral'
	import Loader from '../../../layouts/Loader.vue'
	
	export default {
		props: ['round', 'gameId'],
		data () {
			return {
				panel: []
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			company () {
				return this.$store.getters.company
			},
			adjustedSales () {
				return this.$store.getters.adjustedSales
			},
			products () {
				return this.$store.getters.products
			},
			models () {
				return this.$store.getters.models
			},
			toUpgrade () {
				let resArr = []
				const upgraded = this.$store.getters.toUpgrade
				if (upgraded) {//upgraded of this company
					resArr = upgraded.filter(item => item.company === this.company)
				}
				return resArr
			},
			//group sales per months
			monthSales () {
				//учитываем модели, которые в прошлом раунде были до upgrade
				let uModels = []
				if (this.toUpgrade.length) {
					this.toUpgrade.forEach(item => {
						uModels = uModels.concat(item.models)
					})
				}
				uModels = uModels.concat(this.models)
				//console.log(uModels)
				const resArr = []
				for (let i = 0; i < this.adjustedSales.length; i++) {
					const segSales = this.adjustedSales[i]
					const models = []
					for (let  s = 0; s < segSales.length; s++) {
						if (segSales[s].models.length) {
							for (let m = 0; m < segSales[s].models.length; m++) {
								const companyModel = uModels.find(mod => mod.modelId === segSales[s].models[m].modelId)
								
								if (companyModel) {			
									//sales
									const sales = segSales[s].models[m].adjustedSales

									//in models yet??
									const inModels = models.find(item => item.modelId === companyModel.modelId)

									if (inModels) {
										inModels.sales+= sales 
									}
									else {
										models.push({
											modelId: companyModel.modelId,
											model: companyModel.model,
											sales: sales
										})
									}
								}
							}
						}
					}
					resArr.push(models)
				}
				return resArr
			},
			prevRoundModels () {
				const resArr = []
				if (this.monthSales.length) {
					this.monthSales.forEach(month => {
						month.forEach(model => {
							const inResArr = resArr.find(mod => mod.modelId === model.modelId)
							if (!inResArr) {
								resArr.push(model)
							}
						})
					})
				}
				//console.log(resArr)
				return resArr
			},
			prevProducts () {
				const resArr = []
				//upgraded
				this.products.forEach(product => {
					let models = []
					const isUpgrade = this.toUpgrade.find(item => item.id === product.id)
					if (isUpgrade) {
						models = models.concat(isUpgrade.models)
					}
					
					product.models.forEach(model => {
						const matchModel = this.prevRoundModels.find(mod => mod.modelId === model.modelId)
						if (matchModel) {
							models.push(model)
						}
					})

					if (models.length) {
						resArr.push({
							trademark: product.trademark,
							id: product.id,
							company: product.company,
							models: models
						})
					}
				})
				return resArr
			}
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('0,0[.]0')//
			},
			name (model) {
				return model.split(' - ')[1] //trademark cutted name
			},
			sortArrObjs (arr) {
				//sort models
				arr.sort((prev, next) => {
					let p = prev.model.toLowerCase()
					let n = next.model.toLowerCase()
					if (p < n) return -1;
					if (p > n) return 1;
					return 0;
				})
				return arr
			},
			sortedModels(models) {
				return this.sortArrObjs(models)
			},
			monthName (month) {
				let mon = ''
				switch (month) {
					case 2: mon = 'February'; break;
					case 3: mon = 'March'; break;
					case 4: mon = 'April'; break;
					case 5: mon = 'May'; break;
					case 6: mon = 'June'; break;
					case 7: mon = 'July'; break;
					case 8: mon = 'August'; break;
					case 9: mon = 'September'; break;
					case 10: mon = 'Oktober'; break;
					case 11: mon = 'November'; break;
					case 12: mon = 'December'; break;
					default: mon = 'January'; 
				}
				return mon
			},
			modelSales(month, model) {
				const models = this.monthSales[month - 1]
				
				const matchModel = models.find(mod => mod.modelId === model.modelId)
				
				if (matchModel) return matchModel.sales
				else return 0
			},
			yearSales (model) {
				const arr = []
				for (let i = 0; i < 12; i++) {
					arr[i] = this.modelSales(i+1, model)
				}
				return arr.reduce((sum, item) => {
					return sum+= item
				}, 0)
			},
			trademarkSales(month, trademark) {
				const brand = this.prevProducts.find(item => item.trademark === trademark)
				const models = brand.models
				const res = models.reduce((sum, model) => {
					return sum+= this.modelSales(month, model)
				}, 0)
				return res
			},
			yearBrandSales(trademark) {
				let summ = 0
				for (let i = 0; i < 12; i++) {
					summ+= this.trademarkSales(i + 1, trademark)
				}
				return summ
			},
			//@price - string name of price
			allModelsSales (month, price=null) {
				let sales = 0

				//учитываем модели, которые в прошлом раунде были до upgrade
				let uModels = []
				if (this.toUpgrade.length) {
					this.toUpgrade.forEach(item => {
						uModels = uModels.concat(item.models)
					})
				}
				uModels = uModels.concat(this.models)
				
				if (this.prevRoundModels.length) {
					
					if (!price) {
						this.prevRoundModels.forEach(model => {
							//console.log(this.modelSales(month, model))
							sales+= this.modelSales(month, model)
						})
					}
					else {
					
						this.prevRoundModels.forEach(model => {
							const matchModel = uModels.find(mod => mod.modelId === model.modelId)
							sales+= this.modelSales(month, model) * matchModel[price]
						})
					}
				}
				return sales
			},
			yearModelsSales (price=null) {
				const arr = []
				for (let m = 1; m < 13; m++) {
					if (!price) {
						arr.push(this.allModelsSales(m))
					}
					else {
						arr.push(this.allModelsSales(m, price))
					}
				}
				return arr.reduce((sum,item) => sum + item)
			}
		},
		components: {Loader}
	}
</script>